import { SearchInside } from "@pmag/icons";
import { Typography } from "@pmag/ui-components";
import { ImageStatic } from "@src/components/imageStatic/ImageStatic";
import { Routes } from "@src/context/router/RouterContext";
import { useRouter } from "@src/hooks/useRouter";
import { Images } from "@src/images/Images";
import { type FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";

import {
    ContainerBox,
    LargeImageContainer,
    LeftBox,
    MarginBottomBox,
    SmallImageContainer,
    SmallImageStatic,
    StyledButton,
    TitleTypography,
} from "./CompatibilityCheckTeaser.styles";

export const dataTestId = {
    container: "sparePartsFinder.landingPage.compatibilityCheckTeaser.container",
    openCompatibilityCheckButton: "sparePartsFinder.landingPage.compatibilityCheckTeaser.button",
};

export const CompatibilityCheckTeaser: FunctionComponent = () => {
    const { setRoute } = useRouter();

    return (
        <ContainerBox data-testid={dataTestId.container}>
            <LeftBox>
                <Typography variant="heading-07">
                    <FormattedMessage id="sparePartsFinder.landingPage.compatibilityCheckTeaser.eyebrow" defaultMessage="Spare parts" />
                </Typography>

                <MarginBottomBox>
                    <TitleTypography variant="heading-04">
                        <FormattedMessage id="sparePartsFinder.landingPage.compatibilityCheckTeaser.title" defaultMessage="Compatibility check" />
                    </TitleTypography>
                </MarginBottomBox>

                <MarginBottomBox>
                    <Typography variant="body-short-01">
                        <FormattedMessage
                            id="sparePartsFinder.landingPage.compatibilityCheckTeaser.description"
                            defaultMessage="Search for spare parts or article numbers to see which vehicles they are compatible with."
                        />
                    </Typography>
                </MarginBottomBox>

                <LargeImageContainer>
                    <ImageStatic src={Images.CompatibilityCheck} />
                </LargeImageContainer>

                <StyledButton
                    variant="primary"
                    onClick={() => setRoute(Routes.CompatibilityCheck)}
                    icon={<SearchInside size="small" />}
                    data-testid={dataTestId.openCompatibilityCheckButton}
                >
                    <FormattedMessage id="sparePartsFinder.landingPage.compatibilityCheckTeaser.buttonTitle" defaultMessage="Check compatibility" />
                </StyledButton>
            </LeftBox>

            <SmallImageContainer>
                <SmallImageStatic src={Images.CompatibilityCheck} />
            </SmallImageContainer>
        </ContainerBox>
    );
};
